export type ConnectionType = string;
export const ConnectionTypes: ConnectionType[] = [
  'ADFSSAML',
  'Auth0SAML',
  'AzureSAML',
  'CyberArkSAML',
  'DuoSAML',
  'GenericOIDC',
  'GenericSAML',
  'GoogleOAuth',
  'GoogleSAML',
  'JumpCloudSAML',
  'MicrosoftOAuth',
  'OktaSAML',
  'OneLoginSAML',
  'PingFederateSAML',
  'PingOneSAML',
  'SalesforceSAML',
  'VMwareSAML',
];
export const ConnectionProviders = {
  Auth0SAML: {
    displayName: 'Auth0',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/auth0-logo.731F768-2.svg',
  },
  AzureSAML: {
    displayName: 'Azure',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/azure-logo.B5BB1AF.svg',
  },
  CyberArkSAML: {
    displayName: 'CyberArk',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/cyberark-logo.F6E0E0C.ico',
  },
  DuoSAML: {
    displayName: 'Duo',
    logoUrl:
      'https://storage.googleapis.com/ttc-static-images/sso/duo.CF71C60.png',
  },
  Generic: {
    displayName: 'Generic',
  },
  Google: {
    displayName: 'Google',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/google-logo.053720C.png',
  },
  JumpCloudSAML: {
    displayName: 'JumpCloud',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/jumpcloud-logo.4C85A8E.png',
  },
  Microsoft: {
    displayName: 'Microsoft',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/calendar/microsoft.C711088.svg',
  },
  OktaSAML: {
    displayName: 'Okta',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/okta-logo.DBCBB53.png',
  },
  OneLoginSAML: {
    displayName: 'OneLogin',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/onelogin-logo.8C831A2.png',
  },
  PingFederateSAML: {
    displayName: 'Ping Federate',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/pingfedarate-logo.D5ACFE5.jpg',
  },
  PingOneSAML: {
    displayName: 'Ping One',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/ping-one-logo.5F9BAB7.ico',
  },
  SalesforceSAML: {
    displayName: 'Salesforce',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/salesforce-logo.8E96BC3.svg',
  },
  VMwareSAML: {
    displayName: 'VMware',
    logoUrl:
      '//storage.googleapis.com/ttc-static-images/sso/vmware-logo.2D5E063.png',
  },
};
export const ConnectionConfigs: Record<
  ConnectionType,
  { displayName: string; logoUrl?: string }
> = {
  ADFSSAML: ConnectionProviders.Generic,
  Auth0SAML: ConnectionProviders.Auth0SAML,
  AzureSAML: ConnectionProviders.AzureSAML,
  CyberArkSAML: ConnectionProviders.CyberArkSAML,
  DuoSAML: ConnectionProviders.DuoSAML,
  GenericOIDC: ConnectionProviders.Generic,
  GenericSAML: ConnectionProviders.Generic,
  GoogleOAuth: ConnectionProviders.Google,
  GoogleSAML: ConnectionProviders.Google,
  JumpCloudSAML: ConnectionProviders.JumpCloudSAML,
  MicrosoftOAuth: ConnectionProviders.Microsoft,
  OktaSAML: ConnectionProviders.OktaSAML,
  OneLoginSAML: ConnectionProviders.OneLoginSAML,
  PingFederateSAML: ConnectionProviders.PingFederateSAML,
  PingOneSAML: ConnectionProviders.PingOneSAML,
  SalesforceSAML: ConnectionProviders.SalesforceSAML,
  VMwareSAML: ConnectionProviders.VMwareSAML,
};
